import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { useActions } from 'hooks/useActions';
import * as actions from './actions';
import {
  OuterContainer,
  PrivacyContainer,
  ContainerHeading,
  LabelAndCheckboxContainer,
  TextInput,
  EmailTabContainer,
  EmailContainer,
  Label,
  PrivacyText,
  PrivacyPreviewHeading,
  PrivacyPreviewContainer,
  ErrorMessage,
} from './styles';
import { Button } from '../../components';
import { userRoles } from 'util/appConstants';
import QuillEditor from 'components/QuillEditor/quillEditorEmail';

export default React.memo(({ userRole, companyId }) => {
  const {
    settings: { GDPRAgreement },
  } = useSelector((state) => state.settings);

  const { publishAgreement } = useActions(actions);

  const [GDPRText, setGDPRText] = useState(GDPRAgreement.GDPRText || '');
  const [monthsToDeletion, setMonthsToDeletion] = useState(GDPRAgreement.monthsToDeletion);
  const [formError, setFormError] = useState('');

  const allowEdit = [userRoles.COMPANY_ADMIN, userRoles.SUPER_ADMIN].includes(userRole);

  const updateAgreement = () => {
    let privacyPreview = document.getElementById('privacy-preview');
    if (!monthsToDeletion || monthsToDeletion < 1 || monthsToDeletion > 60) {
      setFormError('Retention must be a number between 1 and 60');
    } else if (String(privacyPreview.innerText).length <= 1) {
      setFormError('New privacy text missing');
    } else {
      setFormError('');
      publishAgreement(companyId, {
        GDPRText,
        monthsToDeletion,
      });
    }
  };

  return (
    <OuterContainer>
      <ContainerHeading>Privacy Settings</ContainerHeading>
      <PrivacyContainer>
        <PrivacyText>
          The text below will be displayed to every candidate the first time they start taking a test sent out by your
          company. Before they can start taking the test they must accept the contents of the text.
        </PrivacyText>
        {allowEdit && (
          <LabelAndCheckboxContainer>
            <TextInput
              type="number"
              isEditing={true}
              padding="5px 5px 0 5px"
              height="30px"
              width="45px"
              onChange={(e) => setMonthsToDeletion(e.target.value)}
              value={monthsToDeletion}
            />
            <Label isInputNumberLabel>Months of data retention before automatic deletion of test and report data</Label>
          </LabelAndCheckboxContainer>
        )}
        {!allowEdit && <PrivacyText>{monthsToDeletion} Months of data retention before automatic deletion</PrivacyText>}
        {allowEdit && (
          <>
            <EmailTabContainer grids={2} gridGap="35">
              <EmailContainer>
                <QuillEditor
                  id="enHtml"
                  placeholder="Email template"
                  value={GDPRText}
                  height="165px"
                  className="privacy"
                  onChange={(updatedValue) => setGDPRText(updatedValue)}
                />
              </EmailContainer>
              <EmailContainer>
                <PrivacyPreviewHeading>Privacy Preview</PrivacyPreviewHeading>
                <PrivacyPreviewContainer
                  dangerouslySetInnerHTML={{
                    __html: GDPRText,
                  }}
                  id="privacy-preview"
                ></PrivacyPreviewContainer>
              </EmailContainer>
            </EmailTabContainer>
            {formError && <ErrorMessage>{formError}</ErrorMessage>}
            <Button
              small
              primaryBlue
              primaryGreenBorder
              removeMargin
              margin="15px 0 0 0px"
              onClick={() => updateAgreement()}
            >
              Save
            </Button>
          </>
        )}
      </PrivacyContainer>
    </OuterContainer>
  );
});
